// Збирає всі двомовні поля форми у пари шляхів для перекладача.
//
// У програмі таких полів кілька десятків, і вони лежать на різній глибині:
// hero.title, overview.paragraphs[2], methodology.items[0].text,
// highlightSection.audienceItems[3]. Перелічувати їх руками означало б
// забути половину при кожній зміні форми, тому шукаємо їх обходом значень.

const LOCALE_KEYS = ['ua', 'en'];

const isLocalizedText = (value) =>
  Boolean(value) &&
  typeof value === 'object' &&
  !Array.isArray(value) &&
  Object.keys(value).length > 0 &&
  Object.keys(value).every((key) => LOCALE_KEYS.includes(key));

export function collectLocalizedPairs(values, { from = 'ua', to = 'en', onlyEmptyTarget = true } = {}) {
  const pairs = [];
  let filled = 0;

  const walk = (node, path) => {
    if (isLocalizedText(node)) {
      const source = String(node[from] || '').trim();
      const target = String(node[to] || '').trim();

      if (!source) return;

      if (target) {
        filled += 1;
        if (onlyEmptyTarget) return;
      }

      pairs.push({ from: `${path}.${from}`, to: `${path}.${to}` });
      return;
    }

    if (Array.isArray(node)) {
      // Індекс через крапку, а не [0]: так шлях читається і простим
      // split('.'), і formik-івським setFieldValue.
      node.forEach((item, index) => walk(item, `${path}.${index}`));
      return;
    }

    if (node && typeof node === 'object') {
      Object.entries(node).forEach(([key, item]) => walk(item, path ? `${path}.${key}` : key));
    }
  };

  walk(values, '');

  return { pairs, filled };
}
